// extracted by mini-css-extract-plugin
export var accordionGroupContainer = "P_cz";
export var accordionListContainer = "P_cC";
export var accordionListHeadlines = "P_cB";